import * as React from "react";
function SvgArrowDown(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <g clipPath="url(#arrow-down_svg__clip0_2_3111)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.293 13.707l7 7a1 1 0 001.414 0l7-7-1.414-1.414L13 17.586V3h-2v14.586l-5.293-5.293-1.414 1.414z"
                    fill="currentcolor"
                />
            </g>
            <defs>
                <clipPath id="arrow-down_svg__clip0_2_3111">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgArrowDown);
export default ForwardRef;
